import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi } from '@mint-sdk/api-core';
import type { z } from 'zod';

import { GetRowsResponseSchema } from '../shared/schemas/rows.js';

export type GetRowsResponse = z.infer<typeof GetRowsResponseSchema>;

export const getRows = defaultApi.declareEndpoint({
  url: 'planning-service/media-plans/$planId/activities/platforms/media_rows/' as const,
  method: 'GET',
  responseSchema: GetRowsResponseSchema,
});

export const getRowsQueryOptions = makeQueryOptions(getRows, {
  processResponse(data) {
    return data;
  },
});
